import React from 'react';
import SEO from '../components/SEO';
import { trackButtonClick } from '../components/Analytics';
import careersTeam from '../assets/images/careers-team.jpg';

function Careers() {
  return (
    <div>
      <SEO 
        title="Careers - Join the Vithminds Team"
        description="Join Vithminds Technologies and work on cutting-edge AI projects for Fortune 500 companies. We offer innovation, growth, and global exposure in AI and digital transformation."
        keywords="AI careers, digital transformation jobs, AI engineer jobs, Hyderabad tech jobs, enterprise AI careers"
      />
      {/* Hero Section */}
      <section className="careers-hero">
        <div className="careers-hero-content">
          <h1>Join the Winning Team</h1>
          <p>
            Vithminds goes beyond the brief to nurture a culture of trust, empowerment, and respect. 
            We believe that AI is truly an instrument for human amplification. We are building teams 
            that believe in and benefit from the human-AI collaboration based on a foundation of lifelong learning.
          </p>
          <a 
            href="/contact-us" 
            className="careers-apply-btn"
            onClick={() => trackButtonClick('Apply Now', 'Careers Hero')}
            aria-label="Apply for a position at Vithminds"
          >
            Apply Now
          </a>
        </div>
        <div className="careers-hero-image">
          <img src={careersTeam} alt="Team" />
        </div>
      </section>

      {/* Why Join Us Section */}
      <section className="section">
        <h2 className="section-title">Why Vithminds?</h2>
        <p className="section-subtitle">
          Join a company that values innovation, expertise, and growth
        </p>
        <div className="grid-3">
          <div className="card shine-effect">
            <div className="card-icon">🚀</div>
            <h3 className="card-title">Innovation at Scale</h3>
            <p className="card-text">
              Work on cutting-edge AI and digital transformation projects for 
              Fortune 500 companies and global enterprises.
            </p>
          </div>
          <div className="card shine-effect">
            <div className="card-icon">📈</div>
            <h3 className="card-title">Career Growth</h3>
            <p className="card-text">
              Accelerate your career with mentorship from industry leaders and 
              exposure to diverse, challenging projects.
            </p>
          </div>
          <div className="card shine-effect">
            <div className="card-icon">🌐</div>
            <h3 className="card-title">Global Exposure</h3>
            <p className="card-text">
              Collaborate with international teams and work on projects that 
              impact businesses across the globe.
            </p>
          </div>
          <div className="card shine-effect">
            <div className="card-icon">🧠</div>
            <h3 className="card-title">Learning Culture</h3>
            <p className="card-text">
              Continuous learning opportunities with access to latest technologies, 
              certifications, and training programs.
            </p>
          </div>
          <div className="card shine-effect">
            <div className="card-icon">⚖️</div>
            <h3 className="card-title">Work-Life Balance</h3>
            <p className="card-text">
              Flexible work arrangements with remote options and a supportive 
              environment that values your well-being.
            </p>
          </div>
          <div className="card shine-effect">
            <div className="card-icon">🎉</div>
            <h3 className="card-title">Competitive Benefits</h3>
            <p className="card-text">
              Attractive compensation packages, health benefits, and perks that 
              recognize your valuable contributions.
            </p>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="careers-cta-section">
        <div className="careers-cta-content">
          <h2>Build AI that works for you</h2>
          <p>Talk to us today about crafting a custom AI solution tailored to your business.</p>
          <a href="/contact-us" className="careers-cta-button">Book a free Consultation</a>
        </div>
      </section>
    </div>
  );
}

export default Careers;
